import type { Article, ArticleCreatePayload, ArticleUpdatePayload } from "../types/article";
import { API_BASE, apiFetch, getAuthHeaders, handleUnauthorized } from "./client";

export async function listArticles(): Promise<Article[]> {
  return apiFetch<Article[]>("/api/v1/admin/articles");
}

export async function getArticle(id: string): Promise<Article> {
  return apiFetch<Article>(`/api/v1/admin/articles/${id}`);
}

export async function createArticle(payload: ArticleCreatePayload): Promise<Article> {
  return apiFetch<Article>("/api/v1/admin/articles", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateArticle(id: string, payload: ArticleUpdatePayload): Promise<Article> {
  return apiFetch<Article>(`/api/v1/admin/articles/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function deleteArticle(id: string): Promise<void> {
  await apiFetch<void>(`/api/v1/admin/articles/${id}`, { method: "DELETE" });
}

export async function uploadCover(articleId: string, file: File): Promise<Article> {
  const headers = await getAuthHeaders() as Record<string, string>;
  delete headers["Content-Type"];
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch(`${API_BASE}/api/v1/admin/articles/${articleId}/cover`, {
    method: "POST",
    headers,
    body: formData,
  });
  if (response.status === 401) return handleUnauthorized(response);
  if (!response.ok) {
    const detail = await response.text().catch(() => "Upload failed");
    throw new Error(`Upload error ${response.status}: ${detail}`);
  }
  return response.json() as Promise<Article>;
}
